<template>
  <div class="dt-buttons btn-group">
    <button class="btn btn-secondary buttons-copy buttons-html5" @click="copy">
      <span>{{ $t('button.copy') }}</span>
    </button>
    <button class="btn btn-secondary buttons-csv buttons-html5" @click="csv">
      <span>{{ $t('button.csv') }}</span>
    </button>
    <button class="btn btn-secondary buttons-excel buttons-html5" @click="excel_selected" v-if="!export_selected_exists">
      <span>{{ $t('button.excel-selected') }}</span>
    </button>
    <button class="btn btn-secondary buttons-excel buttons-html5" @click="excel_selected_all" v-if="export_selected_exists">
      <span>{{ $t('button.excel-selected') }}</span>
    </button>
    <button class="btn btn-secondary buttons-excel buttons-html5" @click="excel_all" v-if="export_exists">
      <span>{{ $t('button.excel-all') }}</span>
    </button>
    <button class="btn btn-secondary buttons-pdf buttons-html5" @click="pdf">
      <span>{{ $t('button.pdf') }}</span>
    </button>
    <button class="btn btn-secondary buttons-print" @click="print">
      <span>{{ $t('button.print') }}</span>
    </button>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import * as JsPDF from 'jspdf'
import 'jspdf-autotable'

export default {
  computed: {
    export_exists() {
      return this.$parent.export_all_rows !== undefined
    },
    export_selected_exists() {
      return this.$parent.export_selected_rows !== undefined
    }
  },
  methods: {
    copy () {
      if (this.$parent.selected.length > 0) {
        let copyData = ''
        this.$parent.columns.forEach(col => {
          copyData += col + '\t'
        })
        copyData = copyData.slice(0, -1) + '\n'
        this.$parent.rowsData.forEach(row => {
          this.$parent.selected.forEach(sel => {
            if (sel === row[0]) {
              for (let i = 1; i < Object.keys(row).length; i++) {
                copyData += row[i] + '\t'
              }
              copyData = copyData.slice(0, -1) + '\n'
            }
          })
        })
        this.$clipboard(copyData)
        this.$swal({
          type: 'info',
          title: this.$i18n.t('datatablebuttons.copy'),
          text: this.$i18n.t('datatablebuttons.copied')
        })
      }
    },
    csv () {
      if (this.$parent.selected.length > 0) {
        let csvContent = 'data:text/csv;charset=utf-8,'
        let copyData = ''
        this.$parent.columns.forEach(col => {
          copyData += col + ';'
        })
        copyData = copyData.slice(0, -1) + '\n'
        this.$parent.rowsData.forEach(row => {
          this.$parent.selected.forEach(sel => {
            if (sel === row[0]) {
              for (let i = 1; i < Object.keys(row).length; i++) {
                copyData += row[i] + ';'
              }
              copyData = copyData.slice(0, -1) + '\n'
            }
          })
        })
        csvContent += copyData
        const data = encodeURI(csvContent)
        const link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', 'export.csv')
        link.click()
      }
    },
    excel_selected () {
      if (this.$parent.selected.length > 0) {
        let copyJson = []
        this.$parent.rowsData.forEach(row => {
          this.$parent.selected.forEach(sel => {
            if (sel === row[0]) {
              let rowJson = {}
              let i = 1
              this.$parent.columns.forEach(col => {
                rowJson[col] = row[i]
                i += 1
              })
              copyJson.push(rowJson)
            }
          })
        })
        let dataWS = XLSX.utils.json_to_sheet(copyJson)
        let wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS, 'data')
        XLSX.writeFile(wb, 'export.xlsx')
      }
    },
    excel_selected_all () {
      this.$parent.export_selected_rows()
    },
    excel_all () {
      this.$parent.export_all_rows()
    },
    pdf () {
      if (this.$parent.selected.length > 0) {
        let doc = new JsPDF('landscape')
        let head = [this.$parent.columns]
        let body = []
        this.$parent.rowsData.forEach(row => {
          this.$parent.selected.forEach(sel => {
            if (sel === row[0]) {
              let rowBody = []
              for (let i = 1; i < Object.keys(row).length; i++) {
                rowBody.push(row[i])
              }
              body.push(rowBody)
            }
          })
        })
        doc.autoTable({
          head: head,
          body: body
        })
        doc.save('export.pdf')
      }
    },
    print () {
      if (this.$parent.selected.length > 0) {
        let doc = new JsPDF('landscape')
        let head = [this.$parent.columns]
        let body = []
        this.$parent.rowsData.forEach(row => {
          this.$parent.selected.forEach(sel => {
            if (sel === row[0]) {
              let rowBody = []
              for (let i = 1; i < Object.keys(row).length; i++) {
                rowBody.push(row[i])
              }
              body.push(rowBody)
            }
          })
        })
        doc.autoTable({
          head: head,
          body: body
        })
        doc.autoPrint()
        doc.output('dataurlnewwindow')
      }
    }
  },
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Datatablebuttons.vue